import { cn } from "@roman/shared/utils";

interface TagProps {
  text: string;
  className?: string;
}

export const Tag = ({ text, className }: TagProps) => {
  return (
    <span
      className={cn(
        "rounded-full inline-block text-dark-gray text-xs leading-3 font-medium border border-dark-gray px-[14px] py-[5px]",
        className,
      )}
    >
      {text}
    </span>
  );
};
